<template>
  <div
    id="htmlEditor"
  />
</template>

<script>
export default {
  name: 'HtmlEditor',

  props: {
    value: {
      type: String,
      default: ''
    },
    init: {
      type: Object,
      default: () => ({})
    },
    initialValue: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      editorInstance: null
    }
  },

  computed: {
    editableContent: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (this.editorInstance && newVal && this.editorInstance.getContent() !== newVal) {
          this.editorInstance.setContent(newVal || '')
        }
      }
    }
  },

  mounted () {
    this.injectTinyMCE().then(() => {
      if (window.tinymce) {
        const that = this
        window.tinymce.init({
          selector: '#htmlEditor',
          license_key: 'gpl', // because of warning: tinymce.min.js:11 TinyMCE is running in evaluation mode. Provide a valid license key or add license_key: 'gpl' to the init config to agree to the open source license terms. Read more at https://www.tiny.cloud/license-key/
          menubar: false,
          plugins: 'lists',
          toolbar: 'undo redo bold italic underline align numlist bullist',
          setup: (editor) => {
            that.editorInstance = editor
            editor.on('init', () => {
              editor.setContent(this.editableContent)
            })

            editor.on('Change KeyUp', () => {
              that.$emit('input', editor.getContent())
            })
          },
          ...this.init
        })
      }
      else {
        console.error('TinyMCE is not available on window')
      }
    })
  },

  beforeDestroy () {
    if (this.editorInstance) {
      this.editorInstance.remove()
      this.editorInstance = null
    }
  },

  methods: {
    injectTinyMCE () {
      const jsId = 'tiny-js'

      return new Promise((resolve) => {
        if (!document.getElementById(jsId)) {
          const script = document.createElement('script')
          script.id = jsId
          script.src = '/js/tinymce/tinymce.min.js'
          script.onload = resolve
          document.body.appendChild(script)
        }
        else {
          resolve()
        }
      })
    }
  }
}
</script>

<style>
.tox-tinymce {
  flex: 1 1 auto;
  flex-grow: 1;
  height: unset !important;
  border: unset !important;
}
</style>
